import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Text } from '@/components/ui/text';
import { Trash } from 'lucide-react';
import { useState, type FC, type ReactNode } from 'react';

interface DeleteColumnConfirmModalProps {
  columnName: string;
  onConfirm: () => void;
  children: ReactNode;
}

export const DeleteColumnConfirmModal: FC<DeleteColumnConfirmModalProps> = ({
  columnName,
  onConfirm,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleConfirm = () => {
    onConfirm();
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Delete column?</DialogTitle>
          <DialogDescription>
            <Text variant="body-sm" color="primary">
              All extracted data in the <strong>{columnName}</strong> column
              will be lost. This action can not be undone. Are you sure you want
              to continue?
            </Text>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">Cancel</Button>
          </DialogClose>
          <Button variant="destructive" onClick={handleConfirm}>
            <Trash />
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
